import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import App from './App.jsx';
import { store } from './store';
import { initStoreRef } from './store/storeRef';
import { initIframeBridge } from './utils/iframe';
import './index.css';

// Store referansını apiClient katmanına açıkla — 401'de doğrudan dispatch
// yapabilsin (circular import olmadan).
initStoreRef(store);

// iframe entegrasyonu — parent spine app'ten JWE token'ı postMessage ile al.
// Spine app iframe'e src verdiğinde otomatik olarak token push eder.
initIframeBridge();

const BASE_PATH = import.meta.env.VITE_BASE_PATH || '/';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={BASE_PATH}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
